import Types from './types';

export default class Dispatcher {
    constructor(dispatch) {
        this.dispatch = dispatch;
    }

    // Dashboard
    fetchDashboardStart = () => this.dispatch({ type: Types.FETCH_DASHBOARD_START, payload: {} });

    // Wellness Summary (NOM-035)
    fetchWellnessSummaryStart = (params) => this.dispatch({ type: Types.FETCH_WELLNESS_SUMMARY_START, payload: params || {} });

    // Employees
    fetchEmployeesStart = (params) => this.dispatch({ type: Types.FETCH_EMPLOYEES_START, payload: params });

    addEmployeeStart = (data) => this.dispatch({ type: Types.ADD_EMPLOYEE_START, payload: data });

    deleteEmployeeStart = (id) => this.dispatch({ type: Types.DELETE_EMPLOYEE_START, payload: id });

    assignSessionsStart = (id, sessions) => this.dispatch({ 
        type: Types.ASSIGN_SESSIONS_START, 
        payload: { id, sessions } 
    });

    // Tokens
    fetchTokenHistoryStart = () => this.dispatch({ type: Types.FETCH_TOKEN_HISTORY_START, payload: {} });

    purchaseTokensStart = (data) => this.dispatch({ type: Types.PURCHASE_TOKENS_START, payload: data });

    // Reports
    exportNOM035Start = (params) => this.dispatch({ type: Types.EXPORT_NOM035_START, payload: params });

    resetError = () => this.dispatch({ type: Types.RESET_ERROR, payload: {} });
}
